import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { useGetIntegrations } from 'modules/movableInk/hooks/useGetIntegrations';
import { MI } from 'modules/movableInk';

export const useHasMovableInkTile = () => {
  const isMovableInkEnabled = useFeatureFlag(MI);
  const { data: integrations, isLoading } = useGetIntegrations();

  return isMovableInkEnabled && !isLoading && integrations.length > 0;
};
